import { render, staticRenderFns } from "./jnzyxy.vue?vue&type=template&id=0c1ed142&scoped=true&"
import script from "./jnzyxy.vue?vue&type=script&lang=js&"
export * from "./jnzyxy.vue?vue&type=script&lang=js&"
import style0 from "./jnzyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./jnzyxy.vue?vue&type=style&index=1&id=0c1ed142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ed142",
  null
  
)

export default component.exports